import { useEffect, useState } from 'react';
import { addNetworkListener, getIsOnline } from '../platform/network';

export function useNetworkStatus(): boolean {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    getIsOnline().then(setIsOnline);
    const cleanup = addNetworkListener(setIsOnline);
    return cleanup;
  }, []);

  return isOnline;
}
